import { render, staticRenderFns } from "./work-orders.vue?vue&type=template&id=521c3848"
import script from "./work-orders.vue?vue&type=script&lang=js"
export * from "./work-orders.vue?vue&type=script&lang=js"
import style0 from "./work-orders.vue?vue&type=style&index=0&id=521c3848&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports